import { FC, useCallback } from 'react';
import { useSelector, useDispatch } from '@cbridge-utils/react-redux';
import { useIsReadOnly } from '@cbridge-packages/auth';
import { GridActionSwitch } from '@cbridge-tools/default-data-grid';
import { isAlertCellProcessingSelector } from '../../_selectors/isAlertCellProcessing.selector';
import { AlertSubscriptionAction } from '../../alertSubscription.action';
import { IAlertSettingsEnabledCellProps } from './AlertSettingsEnabledCell.interface';

export const AlertSettingsEnabledCell: FC<IAlertSettingsEnabledCellProps> = ({ type, enabled }) => {
  const dispatch = useDispatch();
  const isReadOnly = useIsReadOnly();
  const isProcessing = useSelector(isAlertCellProcessingSelector, { cellKey: type });

  const handleToggle = useCallback(
    (checked: boolean) => {
      dispatch(AlertSubscriptionAction.updateSubscription.started({ type, enabled: checked }));
    },
    [dispatch, type],
  );

  return (
    <GridActionSwitch
      checked={enabled}
      disabled={isReadOnly || isProcessing}
      loading={isProcessing}
      onChange={handleToggle}
    />
  );
};
